import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { IGenericPayload } from "../../../models/payload";
import { IUserSignup } from "../../../pages/login/container";

interface IDetailRequestFormState {
    form: IUserSignup;
}

const initialState: IDetailRequestFormState = {
    form: {
        phoneNumber: "",
        organizationId: "",
    },
};

export const userSignupFormReducer = createSlice({
    name: "userSignupFormReducer",
    initialState,
    reducers: {
        resetuserSignupForm: () => initialState,
        updateuserSignupProperty: (state, action: PayloadAction<IGenericPayload>) => {
            state.form = {
                ...state.form,
                [action.payload.name]: action.payload.value,
            };
        },
        setUserSignupData: (state, action: PayloadAction<IUserSignup>) => {
            state.form = action.payload;
        },
    },
});

export const { resetuserSignupForm, updateuserSignupProperty,setUserSignupData } = userSignupFormReducer.actions;

export default userSignupFormReducer.reducer;
